import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "animate.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { SkeletonTheme } from "react-loading-skeleton";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <SkeletonTheme baseColor="#0d52962e" highlightColor="#fff">
        <App />
      </SkeletonTheme>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
